const initialState = {}
const filtersReducer = (state = initialState, action) => {
  switch (action.type) {
  case 'MANAGE_ALL_FILTER':
    return {
      ...state,
      allRegionsFilter: action.checked
    }
  case 'MANAGE_REFERENCE_FILTER':
    return {
      ...state,
      referenceRegionsFilter: action.checked
    }
  case 'MANAGE_SAME_COUNTRY_FILTER':
    return {
      ...state,
      sameCountryRegionsFilter: action.checked
    }
  case 'MANAGE_TYPE_AHEAD_FILTER':
    return {
      ...state,
      otherRegionsFilter: action.selected
    }
  case 'MANAGE_EVOLUTION_FILTER':
    return {
      ...state,
      evolutionFilter: action.selected
    }
  case 'MANAGE_CHART_TYPE_FILTER':
    return {
      ...state,
      chartTypeFilter: action.selected
    }
  default:
    return state
  }
}

export default filtersReducer



// WEBPACK FOOTER //
// ./src/redux/Reducers/filtersReducer.js